
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import About from './components/About';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import JobRequest from './components/JobRequest';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-amber-50/30 to-gray-50">
      <Navbar />
      <Hero />
      <Services />
      <Gallery />
      <Testimonials />
      <JobRequest />
      <Contact />
      <About />
      <Footer />
    </div>
  );
}
